module.exports = __webpack_public_path__ + "static/media/SourceSansPro-SemiboldIt.952206d9.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-SemiboldIt.ttf
// module id = 346
// module chunks = 3